import { StaticImage } from "gatsby-plugin-image";
import { Text } from "../Text/Text";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay } from "swiper";
import * as styles from "./carousel.module.scss";
import "swiper/swiper.scss";

interface Props {
  setSwiper: any;
  swiperContainerClass?: string;
}

// SwiperCore.use([Autoplay]);

export const Carousel: React.FC<Props> = ({
  setSwiper,
  swiperContainerClass,
}) => {
  return (
    <div className={styles.wrapper}>
      <Swiper
        slidesPerView={3.2}
        // autoplay={true}
        direction="horizontal"
        // loop={true}
        // loopFillGroupWithBlank={true}
        onSwiper={(swiper) => setSwiper(swiper)}
        // onSlideChange={() => console.log("change")}
        // centeredSlides={true}
        className={swiperContainerClass || styles.swiperContainer}
      >
        <SwiperSlide>
          <div className={styles.card}>
            <StaticImage
              src={"../../../static/images/01_Luca.jpg"}
              alt={"card"}
              // width={120}
              // height={162}
              objectFit="cover"
              objectPosition={"center"}
            />

            <div className={styles.content}>
              <Text text={"Luca Cordaro"} className={styles.name} />
              <Text text={"Italy"} className={styles.country} />
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className={styles.card}>
            <StaticImage
              src={"../../../static/images/03_rRobert.jpg"}
              // height={162}
              // width={120}
              objectFit="cover"
              objectPosition={"center"}
              alt={"card"}
            />

            <div className={styles.content}>
              <Text text={"Robert Haas"} className={styles.name} />
              <Text text={"Austria"} className={styles.country} />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className={styles.card}>
            <StaticImage
              src={"../../../static/images/04_Turker.jpg"}
              // height={162}
              // width={120}
              objectFit="cover"
              objectPosition={"center"}
              alt={"card"}
            />

            <div className={styles.content}>
              <Text text={"Türker Örnekol"} className={styles.name} />
              <Text text={"Turkey"} className={styles.country} />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className={styles.card}>
            <StaticImage
              src={"../../../static/images/05_Jode-Manuel.jpg"}
              // height={162}
              // width={120}
              objectFit="cover"
              objectPosition={"center"}
              alt={"card"}
            />

            <div className={styles.content}>
              <Text text={"José Manuel Navarro"} className={styles.name} />
              <Text text={"Spain"} className={styles.country} />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className={styles.card}>
            <StaticImage
              src={"../../../static/images/06_Lukas.jpg"}
              // height={162}
              // width={120}
              objectFit="cover"
              objectPosition={"center"}
              alt={"card"}
            />

            <div className={styles.content}>
              <Text text={"Lukas Fürhauser"} className={styles.name} />
              <Text text={"Austria"} className={styles.country} />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className={styles.card}>
            <StaticImage
              src={"../../../static/images/07_Joao.jpg"}
              // height={162}
              // width={120}
              objectFit="cover"
              objectPosition={"center"}
              alt={"card"}
            />

            <div className={styles.content}>
              <Text text={"João Pitta"} className={styles.name} />
              <Text text={"Switzerland"} className={styles.country} />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className={styles.card}>
            <StaticImage
              src={"../../../static/images/massimo-frosecchi.jpg"}
              // height={162}
              // width={120}
              objectFit="cover"
              objectPosition={"center"}
              alt={"card"}
            />

            <div className={styles.content}>
              <Text text={"Massimo Frosecchi"} className={styles.name} />
              <Text text={"Italy"} className={styles.country} />
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};
